import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpClientModule,
} from "@angular/common/http";
import { timeout } from "rxjs/operators";
declare function require(url: string);

const conf = require("assets/appconf.json");

@Injectable({
  providedIn: "root",
})
export class wsWebScraping {
  private webScrapingUrl = "http://191.252.0.92:9000/concorrente";
  private spaUrl = conf.server.url;
  private serverUrls = {
    webScrapingUrl: this.webScrapingUrl,
    spaUrl: this.spaUrl,
  };
  private headers = new HttpHeaders();

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders()
      .append("Authorization", "Basic c3BhLXBhaW5lbDpjMnB5VzJGbkNyUTI=")
      .append("Content-Type", "application/json");
  }

  /**
   * Obtém uma função do servidor e retorna o resultado da requisição HTTP.
   *
   * @param funcao A função a ser chamada no servidor.
   * @param parametro O parâmetro a ser passado para a função (opcional).
   * @param server O servidor no qual a função será chamada.
   * @returns Um Observable que emite o resultado da requisição HTTP.
   */
  public getFunction(funcao, parametro, server) {
    // console.log(this[server] + '/' + funcao + '/' + parametro);
    if (parametro === false) {
      return this.http
        .get(`${this.serverUrls[server]}/${funcao}`, { headers: this.headers })
        .pipe(timeout(60000));
    } else {
      return this.http
        .get(`${this[server]}/${funcao}/${parametro}`, {
          headers: this.headers,
        })
        .pipe(timeout(60000));
    }
  }

  /**
   * Envia um objeto para o servidor por meio de uma requisição HTTP POST.
   *
   * @param objeto O objeto a ser enviado para o servidor.
   * @param server O servidor no qual o objeto será enviado.
   * @returns Um Observable que emite o resultado da requisição HTTP POST.
   */
  public setFunction(objeto, server) {
    const url = `${this.serverUrls[server]}`;
    return this.http.post(url, JSON.stringify(objeto), {
      headers: this.headers,
    });
  }

  /**
   * Atualiza um objeto no servidor por meio de uma requisição HTTP PUT.
   *
   * @param funcao A função utilizada para identificar o objeto a ser atualizado.
   * @param objeto O objeto a ser atualizado no servidor.
   * @param server O servidor no qual o objeto será atualizado.
   * @returns Um Observable que emite o resultado da requisição HTTP PUT.
   */
  public putFunction(funcao, objeto, server) {
    const url = `${this.serverUrls[server]}/${funcao}`;
    return this.http.put(url, JSON.stringify(objeto), {
      headers: this.headers,
    });
  }

  /**
   * Realiza uma requisição HTTP POST assíncrona para um ou mais objetos no servidor.
   *
   * @param funcao A função utilizada para identificar os objetos a serem enviados.
   * @param objeto O(s) objeto(s) a ser(em) enviado(s) para o servidor.
   * @param server O servidor no qual o(s) objeto(s) será(ão) enviado(s).
   * @returns Uma Promise que é resolvida quando todas as requisições HTTP POST forem concluídas.
   */
  public postAsyncFunction(funcao, objeto, server) {
    const promises = funcao.map((item) => {
      const url = `${this.serverUrls[server]}/${item.nome}`; // Update the URL with this.pythonUrl
      return this.http
        .post(url, objeto, {
          headers: this.headers,
        })
        .toPromise();
    });
    return Promise.all(promises);
  }

  /**
   * Realiza uma requisição HTTP POST síncrona para um objeto no servidor.
   *
   * @param funcao A função utilizada para identificar o objeto a ser enviado.
   * @param objeto O objeto a ser enviado para o servidor.
   * @param server O servidor para o qual o objeto será enviado.
   * @returns Uma Promise que é resolvida quando a requisição HTTP POST for concluída.
   */
  public postFunction(funcao, objeto, server) {
    const url = `${this[server]}/${funcao}`;
    return this.http.post(url, JSON.stringify(objeto), {
      headers: this.headers,
    });
  }
}
